import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { profileIncomplete } from '../../main/apps/people/store/person';

const WhiteButton = ({ content, onClick }) => {
	return (
		<div
			onClick={onClick}
			className='m-auto rounded-full bg-white hover:bg-black hover:text-white cursor-pointer p-3 text-center text-xs uppercase'
		>
			{content}
		</div>
	);
};

function UserActionButton() {
	const proposals = useSelector(({ entities }) => entities.proposals.list);
	const loans = useSelector(({ entities }) => entities.loans.list);
	const person = useSelector(({ entities }) => entities.person.data);
	const history = useHistory();

	const handleNewLoan = () => {
		history.push('/proposals/new');
	};

	const handleProfile = e => {
		history.push('/profile');
	};

	if (person && profileIncomplete(person)) {
		return <WhiteButton content={'COMPLETE PROFILE'} onClick={handleProfile} />;
	}

	if (proposals?.length === 0 && loans?.length === 0) {
		return <WhiteButton content={'APPLY FOR A LOAN'} onClick={handleNewLoan} />;
	}
	return <></>;
}

export default UserActionButton;
